module.exports = __webpack_public_path__ + "media/site_templates/www.cheapgardenservices.com.au/images/our_services_1-a6b80997b28b02fb01568e5e54544f58.jpg";